export const state = () => ({
    id: null,
    size: null,
});

export const mutations = {
    setNotify(state, notify) {
        state.id = notify.id;
        state.size = notify.size;
    },
};

export const getters = {
    getId(state) {
        return state.id;
    },
    getSize(state) {
        return state.size;
    },
};

export const actions = {
    setNotify({ commit }, notify) {
        commit("setNotify", notify);
    },
};
